import { Component, OnInit, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faSolidMagnifyingGlass, faSolidXmark } from '@ng-icons/font-awesome/solid';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs';

const DEBOUNCE_TIME = 300;

@Component({
    selector: 'app-glossary-search',
    imports: [NgIcon, ReactiveFormsModule],
    providers: [provideIcons({ faSolidMagnifyingGlass, faSolidXmark })],
    templateUrl: './glossary-search.component.html',
    styleUrl: './glossary-search.component.scss'
})
export class GlossarySearchComponent implements OnInit {
  update = output<string | null>();
  protected query = new FormControl('');

  ngOnInit(): void {
    this.query.valueChanges.pipe(
      debounceTime(DEBOUNCE_TIME)
    ).subscribe(value => this.update.emit(value ?? '')
    );
  }
}
